import { writable } from "svelte/store"

/**
 * Represents a document object.
 * @class
 */
export class AuthenticationObject {
  /**
   * Constructs a new AuthenticationObject instance.
   * @constructor
   */
  constructor() {
    /**
     * Indicates the auth.
     * @type {number}
     * @default undefined
     */
    this.QRCode = ""
  }
}

/**
 * @type {Authenticator} - Retrieving the single publish data from local storage
 */
let stats = localStorage.getItem("P2BAuthStore")

if (typeof stats != "Object") {
  try {
    // Parsing the value as JSON
    stats = JSON.parse(stats)
    if (!stats) {
      // Throwing an error if the parsed value is null
      throw new Error("Document value is null")
    }
  } catch (error) {
    // console.error(error)
    // Initializing stats with a new instance of the SinglePublishObject class
    stats = new AuthenticationObject()
  }
}

/**
 * @typedef {Object} Authenticator - Authentication stats.
 * @type {Object}
 * Authentication stats.
 * 
 * @property {String} QRCode - Authentication QR code.
 * /
 
/**
 * @type {import("svelte/store").Writable<Authenticator>}
 */

const Authenticator = writable(stats)

/**
 * Updates the value of "P2BSinglePublish" in the localStorage.
 * @param {object} stats - The stats object to be stored.
 */
export const UpdateAuthQRCode = (stats) => {
  // Stringify the stats object and store it in the localStorage
  localStorage.setItem("P2BAuthStore", JSON.stringify(stats))
}
export default Authenticator
